import MenuItem from '@mui/material/MenuItem';
import * as Flags from 'country-flag-icons/react/3x2';
import { useStyles } from './styles';
import { countryCodeConverterIso3ToIso2 } from '../../utils/countryCodeConverter';
import { getCountryDisplayName } from '../../features/country/countrySlice';

interface FlagItemProps {
    testid: string;
    item: {
        code: string;
        name: string | { fr?: string; en?: string; ar?: string };
        nameLabel?: string;
        indicatif: string;
    };
    handleCountryChange: (item: any) => void;
}

const FlagItem = ({ testid, item, handleCountryChange }: FlagItemProps) => {
    const classes = useStyles();

    // Convertir le code ISO3 -> ISO2
    const iso2 = countryCodeConverterIso3ToIso2.get(item?.code)?.toUpperCase();

    // Récupérer le composant du drapeau
    const FlagComponent = iso2 ? Flags[iso2 as keyof typeof Flags] : null;

    return (
        <MenuItem
            data-testid={testid}
            style={{ display: 'flex', alignItems: 'center' }}
            onClick={() => handleCountryChange(item)}
        >
            <div className={classes.flagItem}>
                {FlagComponent ? <FlagComponent /> : null}
            </div>

            <span className="country-name">{getCountryDisplayName(item)}</span>
            <span className="dial-code">{` ${item?.indicatif}`}</span>
        </MenuItem>
    );
};

export default FlagItem;
